import type { FC, ReactNode } from 'react'

interface Ray {
    x: number
    width: number
    height: number
    opacity: number
}

const BASE = 190
const SLANT = 0.85

const RAYS: Ray[] = [
    { x: 56, width: 150, height: 150, opacity: 1 },
    { x: 196, width: 118, height: 176, opacity: 0.82 },
    { x: 322, width: 104, height: 168, opacity: 0.66 },
    { x: 438, width: 84, height: 146, opacity: 0.5 },
    { x: 540, width: 58, height: 116, opacity: 0.36 }
]

const shape = ({ x, width, height }: Ray): string => {
    const shift = height * SLANT

    return `${x},${BASE} ${x + width},${BASE} ${x + width - shift},${BASE - height} ${x - shift},${BASE - height}`
}

const edge = ({ x, width, height }: Ray): string => {
    const shift = height * SLANT

    return `M ${x + width} ${BASE} L ${x + width - shift} ${BASE - height}`
}

const RedRays: FC = (): ReactNode => (
    <div aria-hidden='true' className='pointer-events-none relative h-[140px] overflow-hidden sm:h-[190px]'>
        <svg
            viewBox='0 0 640 190'
            preserveAspectRatio='xMidYMax meet'
            className='absolute bottom-0 left-1/2 aspect-[640/190] h-full w-auto max-w-none -translate-x-[46%]'
        >
            <defs>
                <linearGradient id='red-rays-fill' x1='0' y1='0' x2='0' y2='1'>
                    <stop offset='0' stopColor='#ff2a2a' stopOpacity='0' />
                    <stop offset='0.5' stopColor='#ff2f2f' stopOpacity='0.3' />
                    <stop offset='1' stopColor='#ff3a3a' stopOpacity='0.95' />
                </linearGradient>

                <linearGradient id='red-rays-edge' x1='0' y1='0' x2='0' y2='1'>
                    <stop offset='0' stopColor='#ffb3b3' stopOpacity='0' />
                    <stop offset='1' stopColor='#ffc2c2' stopOpacity='0.8' />
                </linearGradient>

                <filter id='red-rays-soft' x='-20%' y='-20%' width='140%' height='140%'>
                    <feGaussianBlur stdDeviation='2.5' />
                </filter>
            </defs>

            {RAYS.map(ray => (
                <g key={ray.x} opacity={ray.opacity}>
                    <polygon points={shape(ray)} fill='url(#red-rays-fill)' filter='url(#red-rays-soft)' />
                    <path d={edge(ray)} stroke='url(#red-rays-edge)' strokeWidth='1.5' fill='none' />
                </g>
            ))}
        </svg>
    </div>
)

export default RedRays
